import { URL } from "../../api/Api";
import { FEEDBACK } from "../Action";
import { catchError, POST } from "../axios/Axios";

export const SubmitFeedback = async (formData) => {
  try {
    const response = await POST(`${URL}/customers/feedback/submit`, formData);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const TranscribeAudio = async (formData) => {
  try {
    const response = await POST(`${URL}/customers/feedback/submit`, formData);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const FeedBackButton = (value) => {
  return {
    type: FEEDBACK.open,
    data: value,
  };
};
